export const canInactivateStore = [
  'smrholding',
  'superpao',
  'compremais',
  'avenidab2c',
]
